import React from 'react';
import Header from '../../blog/Header.js';
import Navbar from '../layouts/components/Navbar.jsx';
import GalleryViewer from './sections/GalleryViewer.jsx';
import AppLayout from '../layouts/AppLayout.jsx';

const AppPhotoGallery = () => {
    return (
       <AppLayout isShowSlider={false}>
               <GalleryViewer />
        </AppLayout>
    );
}

export default AppPhotoGallery;
